import useSWR, {KeyedMutator} from "swr";
import {fetcher} from "./fetcher";
import {EmailLogEntry} from "@app/core-app/app/data/email-log-entry";

export type OutboxLogData = {
  data: EmailLogEntry[] | null | undefined
  isLoading: boolean
  isError: any
  isValidating: boolean
  mutate: KeyedMutator<EmailLogEntry[]>
}


export function useOutboxLog(databaseId: string | null): OutboxLogData {
  const {data, error, mutate, isValidating} = useSWR(
    databaseId ? ["/api/notion/outbox-log", databaseId] : null,
    (key, id) => fetcher(key, {method: "POST", body: JSON.stringify({id: id})})
  )

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating
  }
}


export type OutboxLogDetailedData = {
  data: (EmailLogEntry & any) | null | undefined
  isLoading: boolean
  isError: any
  isValidating: boolean
  mutate: KeyedMutator<EmailLogEntry[]>
}

export function useOutboxLogDetailedStats(logId: string | null): OutboxLogDetailedData{
  const { data, error, mutate, isValidating } = useSWR(
    logId ? `/api/notion/outbox-detailed-stats?logId=${logId}` : null,  // Add logId as query param
    (url) => fetcher(url, { method: "GET" })
  )


  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating
  }
}